var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFloorPlan = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 23,
  height: 23,
  viewBox: "0 0 23 23"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 1h1v22H0zm22 0h1v22h-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 22h23v1H0zM0 0h23v1H0zm5 6h1v11H5zm12.5 4v1h-8v-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 6h1v8H9zm4 4h1v4h-1zm4-4h1v11h-1zM5 5h13v1H5zm0 12h13v1H5z"
}))));
export default SvgFloorPlan;